import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { INITPAGING } from "../based/Constants";
import OrderServices from "../based/services/OrderServices";
import Common from "../based/Common";
import TableFooter from "../based/content/TableFooter";

function WareProductOverview({ returnStatus }) {
    const [lstData, setLstData] = useState([]);
    const [paging, setPaging] = useState({ ...INITPAGING, returnProductStatus: returnStatus });

    console.log("lstData", lstData);

    useEffect(() => {
        fetchData({ ...paging, returnProductStatus: returnStatus, pageNumber: 1 });
    }, [returnStatus]);

    const fetchData = async (paging) => {
        const [err, data] = await OrderServices.GetOrderReturnProductManageModelsByStatus(paging);
        if (!err && data.listObjects) {
            setLstData(data.listObjects);
            setPaging(data.paging);
        } else {
            setPaging(paging);
        }
    };

    return (
        <Wrapper>
            <section className="table-section">
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>Đơn hàng</th>
                            <th>Sản phẩm</th>
                            <th>Ghi chú</th>
                            <th>Hình ảnh</th>
                            <th>Phương án</th>
                        </tr>
                    </thead>
                    <tbody>
                        {lstData && lstData.length > 0 ? (
                            lstData.map((product, index) => {
                                return (
                                    <tr key={index}>
                                        <td>
                                            <div className="order-return-detail">
                                                <div className="order-return-row">
                                                    <div>Ngày trả</div>
                                                    <div>{Common.formatDate(new Date(product.modifiedDate))}</div>
                                                </div>
                                                <div className="order-return-row">
                                                    <div>Partner</div>
                                                    <div>{product.partnerName || "Ranus"}</div>
                                                </div>
                                                <div className="order-return-row">
                                                    <div>Đơn hàng gốc</div>
                                                    <div>
                                                        <a href={`/order-detail/${product.orderId}`} target="_blank" rel="noopener noreferrer">
                                                            {product.orderNumber}
                                                        </a>
                                                    </div>
                                                </div>
                                                <div className="order-return-row">
                                                    <div>Mã hoàn về</div>
                                                    <div>
                                                        <a href={`/return-order-edit/${product.orderId}`} target="_blank" rel="noopener noreferrer">
                                                            {product.orderReturnId}
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="image-section">
                                                <div className="lst-image">
                                                    {product.frontImage && <img src={product.frontImage} alt="Front" />}
                                                    {product.backImage && <img src={product.backImage} alt="Back" />}
                                                </div>
                                                <div className="app-product-detail">
                                                    <div className="app-product-name">{product.appProductName}</div>
                                                    <div className="app-product-attribute">
                                                        {product.color}, {product.size}
                                                    </div>
                                                    <div className="wait-to-fix">
                                                        Mã đợi sửa <strong>{product.barcode}</strong>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="note">{product.note}</div>
                                        </td>
                                        <td>
                                            {/* <div className="list-image-note">
                                                <img src="https://cdn.ranus.vn/images/1/ed7f1784-1cc7-4cc2-8c14-859ec47bc7fc-600x600.webp" alt="" />
                                            </div> */}
                                        </td>
                                        <td>
                                            <div className="text text-danger">{product.returnProductStatusString}</div>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan="5" className="text-center">
                                    Không có dữ liệu
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <TableFooter paging={paging} itemToDisplay={50} onFilter={(paging) => fetchData({ ...paging, returnProductStatus: returnStatus })} />
            </section>
        </Wrapper>
    );
}

export default WareProductOverview;

const Wrapper = styled.div`
    section.table-section {
        margin: 12px 0;
    }

    section.render-lst-button {
        margin: 12px 0;
    }

    section.render-lst-button .btn-primary {
        background: #343c49 !important;
        border: none !important;
    }

    .lst-image img {
        width: 92px;
        height: 92px;
        object-fit: contain;
    }

    tbody tr {
        background: white;
    }

    .image-section {
        display: flex;
        align-items: flex-start;
    }

    .app-product-name {
        overflow: hidden;
        color: #444;
        text-overflow: ellipsis;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin-bottom: 8px;
    }

    .app-product-attribute {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .app-product-detail {
        height: 92px;
        display: flex;
        flex-direction: column;
        flex-grow: 0;
    }

    .wait-to-fix {
        margin-top: auto;
    }

    .order-return-row {
        display: flex;
        margin: 10px 0;
    }

    .order-return-row div:first-child {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        width: 40%;
        text-overflow: ellipsis;
    }

    .order-return-row div:nth-child(2) {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        flex: 1;
    }

    .list-image-note img {
        width: 92px;
        height: 92px;
        margin: 10px;
    }
`;
